<template>
  <li class="comment-item">
    <span class="comment-item__created-at">{{ createdAt() }}</span>
    <span>{{ comment.text }} </span>
  </li>
</template>

<script>
const moment = require('moment')

export default {
  name: 'CommentItem',
  props: {
    comment: Object
  },
  methods:  {
    createdAt: function() {
      return moment(this.comment['created_at']).fromNow()
    }
  }
}
</script>

<style scoped>
  .comment-item {
    border-bottom: 1px solid #ffffff1c;
    margin-bottom: 10px;
    padding: 0px 0px 5px 0px;
  }
  .comment-item__created-at {
    text-align: right;
    display: block;
    padding: 0px 0px 5px 0px;
  }
</style>
